import { ButtonHTMLAttributes, forwardRef } from "react";
import styles from "./Button.module.css";

// Estende as propriedades nativas de um botão HTML
export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
    ({ className, children, ...props }, ref) => {
        // Combina a classe do CSS Module com qualquer className passado via props
        const combinedClassName = `${styles.button} ${className || ""}`.trim();

        return (
            <button ref={ref} className={combinedClassName} {...props}>
                {children}
            </button>
        );
    },
);

Button.displayName = "Button";

export default Button;
